export default __webpack_public_path__ + "static/media/ci.a248a60c.svg";